var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadInstructions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22.652,
    rx: 3.95835,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 8.33594L15.6937 7.61612C15.1691 7.06509 14.5379 6.62657 13.8384 6.32725C13.1389 6.02793 12.3858 5.87406 11.625 5.875C8.51953 5.875 6 8.39454 6 11.5C6 14.6055 8.51953 17.125 11.625 17.125C12.7884 17.1249 13.9231 16.7643 14.8731 16.0927C15.8231 15.4212 16.5416 14.4717 16.9298 13.375",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1875 6.85294V10.0926C18.1875 10.2169 18.1382 10.3361 18.0503 10.424C17.9623 10.512 17.8431 10.5613 17.7188 10.5613H14.4791C14.0614 10.5613 13.8522 10.0566 14.1475 9.76124L17.3874 6.5213C17.6828 6.2254 18.1875 6.43517 18.1875 6.85294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadInstructions);
export default __webpack_public_path__ + "static/media/reload_instructions.9cc2bdfc8b5302f52963ce0174abad79.svg";
export { ForwardRef as ReactComponent };